import r from "./shimmer.vue2.js";
import { openBlock as e, createElementBlock as t, normalizeStyle as s } from "vue";
import "./shimmer.vue3.js";
import c from "../../_virtual/_plugin-vue_export-helper.js";
function n(i, m, p, a, o, l) {
  return e(), t("div", {
    class: "shimmer",
    style: s({ "background-position": o.backgroundPosition }),
    role: "progressbar"
  }, null, 4);
}
const b = /* @__PURE__ */ c(r, [["render", n], ["__scopeId", "data-v-cd7b60f1"]]);
export {
  b as default
};
//# sourceMappingURL=shimmer.vue.js.map
